import React from "react";
import { TableColumn } from 'react-data-table-component';
import LoginServices from "../../../Services/LoginServices";
import moment from "moment";
import DataGrid from "../../../Component/DataGrid/DataGrid";
import { LoginHistoryProps, LoginHistoryState, ILoginHistoryDetails } from "./Interface";

// Main class component for LoginHistory
class LoginHistory extends React.Component<LoginHistoryProps, LoginHistoryState> {
    private tableColumns: TableColumn<ILoginHistoryDetails>[] = [

        {
            name: 'IP Address',
            selector: row => row.ip_address,
            sortable: false,
            id: "IPAddress"
        },
        {
            name: 'Device Info',
            selector: row => row.device_info,
            sortable: true,
            id: "DeviceInfo"
        },
        {
            name: 'Latitude',
            selector: row => row.latitude,
            sortable: false,
            id: "UserEmail"
        },
        {
            name: 'Longitude',
            selector: row => row.longitude,
            sortable: false,
            id: "UserEmail"
        },
        {
            name: 'Last Login',
            selector: row => row.last_login_date,
            sortable: false,
            id: "LastLoginDate"
        },
    ];

    constructor(props: LoginHistoryProps) {
        super(props);
        this.state = {
            data: [],
            currentPage: 1,
            currentRowsPerPage: 10,
            totalRows: 100,
            searchText: "",
        }
    }

    public componentDidMount(): void {
        this.getLoginHistory();
    }

    // Function to get login history data from API
    private getLoginHistory() {
        let pageIndex: number = (this.state.currentPage - 1);
        let pagination: any = {
            "pageNumber": pageIndex,
            "recordPerPage": this.state.currentRowsPerPage,
        };
        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText
        }
        LoginServices.getLoginHistory(pagination, this.props.userId, this.props.accessToken).then(tr => {
            if (tr.ok) {
                tr.json().then(resp => {
                    this.setState({
                        data: resp.userDetailsList.map((history: any) => ({
                            history_Id: history.historyId,
                            ip_address: history.ipAddress,
                            device_info: history.deviceInfo,
                            latitude: history.latitude,
                            longitude: history.longitude,
                            last_login_date: moment(history.lastLoginUTC).format('MM-DD-YYYY hh:mm A'),
                            // geo_location_details: history.geoLocationDetails
                            geo_location_details: ''
                        })),
                        totalRows: resp.pageCount
                    })
                });
            }
        });
    }

    public render() {
        return (
            <>
                <DataGrid
                    gridId="LoginHistory"
                    columns={this.tableColumns}
                    data={this.state.data}
                    defaultSearch={this.state.searchText}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getLoginHistory();
                        })
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                        this.setState({
                            currentRowsPerPage: currentRowsPerPage_,
                            currentPage: currentPage_
                        }, () => {
                            this.getLoginHistory();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getLoginHistory();
                        })
                    }}
                    pagination
                    exportCsv={this.state.data.length ? true : false}
                    paginationTotalRows={this.state.totalRows} />
            </>
        )
    }
}

export default LoginHistory;